// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Mặc định, phần tử sẽ hiển thị */
.head-create {
    display: inline-flex; /* Hiển thị trên màn hình lớn */
    align-items: center;
}

/* Khi màn hình nhỏ hơn 768px (Điện thoại), ẩn phần tử */
@media (max-width: 768px) {
    .head-create {
        display: none; 
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/layout/Header/Header.css"],"names":[],"mappings":"AAAA,kCAAkC;AAClC;IACI,oBAAoB,EAAE,+BAA+B;IACrD,mBAAmB;AACvB;;AAEA,wDAAwD;AACxD;IACI;QACI,aAAa;IACjB;AACJ","sourcesContent":["/* Mặc định, phần tử sẽ hiển thị */\n.head-create {\n    display: inline-flex; /* Hiển thị trên màn hình lớn */\n    align-items: center;\n}\n\n/* Khi màn hình nhỏ hơn 768px (Điện thoại), ẩn phần tử */\n@media (max-width: 768px) {\n    .head-create {\n        display: none; \n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
